import { apiGuestClient } from './apiGuestClient';

export const API_END_POINT = "bus";

export const busApi = {
    selectByHocSinh: (ts_hocsinh_id: number) => apiGuestClient.get(`${API_END_POINT}/dang-ky-xe/${ts_hocsinh_id}`),
};
